import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import App from './App';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import { startVersionCheck } from './utils/versionCheck';

// Identifica el build ante el backend en cada llamada al API. Las peticiones
// sin este header provienen de builds antiguos y el backend les responde con
// Clear-Site-Data para purgar el caché HTTP obsoleto del navegador.
axios.defaults.headers.common['X-KAB-Build'] = process.env.REACT_APP_GIT_SHA || 'dev';

startVersionCheck();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
